import axiosInstance from "./api_helper";

const productService = {
    search: async (query) => {
        return axiosInstance.post(`/api/articles/search`, JSON.stringify(query));
    },

    findAllUnites: async () => {
        return axiosInstance.get(`/api/articles/unites`);
    },

    findBySupplier: async (supplierId, page, size) => {
        return axiosInstance.get(`/api/articles/supplier/${supplierId}?page=${page}&size=${size}`);
    },

    findAllPrices: async (articleId) => {
        return axiosInstance.get(`/api/articles/${articleId}/fournisseurs`);
    },
    delete: async (id) => {
        return axiosInstance.delete(`/api/articles/${id}`);
    },

    checkBarcode: async (barcode) => {
        return axiosInstance.get(`/api/articles/barcode/${barcode}`);
    },

    save: async (formData) => {
        return axiosInstance.post(`/api/articles`, formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });
    },

    findAll: async (search = "", page = 0, size = 10) => {
        const response = await axiosInstance.get(`/api/articles`, {
            params: { search, page, size }
        });
        return response.data;
    },

    findReception: async (search = "", page = 0, size = 10) => {
        const response = await axiosInstance.get(`/api/articles/reception-search`, {
            params: { search, page, size }
        });
        return response.data;
    },

    findLowStock: async () => {
        const response = await axiosInstance.get(`/api/articles/low-stock`);
        return response.data;
    },

    findAllArticles: async (query = "", categorieId = null, page = 0, size = 10) => {
        console.log(categorieId)
        const response = await axiosInstance.get(`/api/articles/all`, {
            params: { query,categorieId, page, size }
        });
        return response.data;
    },

    update: async (id,formData) => {
        return axiosInstance.put(`/api/articles/${id}`, formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });
    },

    findPrixAchat: async (articleId, fournisseurId) => {
        return (await axiosInstance.get(`/api/articles/${articleId}/fournisseurs/${fournisseurId}`)).data.body?.prixAchatHT || 0;
    },

    activate: async (id) => {
        return axiosInstance.put(`/api/articles/activer/${id}`);
    },
    
    upload: async (payload) => {

        return axiosInstance.post(`/api/articles/upload`, payload.formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
    updateGlobalStock: async () => {
        return axiosInstance.post(`/api/articles/update-global-stock`);
    },
    updatePrice: async ({ id, userPrice }) => {
        try {
            return await axiosInstance.patch(`/api/products/${id}/price`, { userPrice });
        } catch (error) {
            throw error.response?.data || error.message;
        }
    }

};
export default productService;
